import {
  RaiseComplaintRequest,
  ApiEnvelope,
  RaiseComplaintResponsePayload,
  ComplaintStatusRequest,
  ComplaintStatusResponsePayload,
  DispositionApiPayload,
} from "store/bbps/Complaint/bbpsComplaintTypes";
import userHttp from "../../axios.services/instances/userHttp";

// If you already have `api` instance in project, use that instead.
// const http: AxiosInstance = axios.create({
//   baseURL: "", // keep empty if same domain; else set env base URL
//   withCredentials: true, // if your auth uses cookies
// });

export const bbpsComplaintService = {
  async raiseComplaint(payload: RaiseComplaintRequest) {
    const res = await userHttp.post<ApiEnvelope<RaiseComplaintResponsePayload>>(
      "/api/v1/bbps/complaint/raise",
      payload,
    );

    return res;
  },

  async complaintStatus(payload: ComplaintStatusRequest) {
    const res = await userHttp.post<
      ApiEnvelope<ComplaintStatusResponsePayload>
    >("/api/v1/bbps/complaint/status", payload);

    // console.log("service: ", res);

    return res;
  },

  async getDispositions() {
    const res = await userHttp.get<ApiEnvelope<DispositionApiPayload>>(
      "/api/v1/bbps/complaint/disposition",
    );

    // console.log("service: ", res);

    return res;
  },
};
